import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {Debugger} from "debug";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";

const debug: Debugger = require('debug')('DokumentsigneringRessurs');

export class DokumentsigneringRessurs {
    static regNavn = 'DokumentsigneringRessurs';

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            Konfigurasjon.regNavn,
            regNavn.gettext.gettextCatalog,
            DokumentsigneringRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<any>;

    constructor(private $resource: ng.resource.IResourceService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private konfigurasjon: Konfigurasjon,
                private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<any>('/api/dokument/signering', {}, {
            signatarer: {method: 'GET', url: '/api/dokument/signering/:dokumentId/signatarer', params: {dokumentId: '@dokumentId'}},
            sendTilSignering: {method: 'POST', url: '/api/dokument/signering/:dokumentId/sendTilSignering', params: {dokumentId: '@dokumentId'}},
            oppdaterSignatarer: {method: 'POST', url: '/api/dokument/signering/:dokumentId/oppdaterSignatarer', params: {dokumentId: '@dokumentId'}},
            markerSomFerdigSignert: {method: 'POST', url: '/api/dokument/signering/:dokumentId/markerSomFerdigSignert', params: {dokumentId: '@dokumentId'}},
            signatarinformasjonForAktivBruker: {method: 'GET', url: '/api/dokument/signering/:dokumentId/signatarinformasjonForAktivBruker', params: {dokumentId: '@dokumentId'}},
            signerUrl: {method: "GET", url: "/api/dokument/signering/:dokumentId/signerUrl/:metode?redirect=false", params: {dokumentId: '@dokumentId', metode: '@metode'}},
            markerSomLest: {method: "POST", url: "/api/dokument/signering/:dokumentId/markerSomLest", params: {dokumentId: '@dokumentId'}},
            sendSmsOtp: {method: "POST", url: "/api/dokument/signering/:dokumentId/sendSmsOtp", params: {dokumentId: '@dokumentId'}},
            signerMedSmsOtp: {method: "POST", url: "/api/dokument/signering/:dokumentId/signerMedSmsOtp", params: {dokumentId: '@dokumentId'}},
            sendPurring: {method: 'POST', url: '/api/dokument/signering/:dokumentId/sendPurring', params: {dokumentId: '@dokumentId'}},
            låsOpp: {method: 'POST', url: '/api/dokument/signering/:dokumentId/laasOpp', params: {dokumentId: '@dokumentId'}},
            finnDokumenterBrukerIkkeHarSignert: {method: 'GET', url: '/api/dokument/signering/finnDokumenterBrukerIkkeHarSignert'},
            finnDokumenterSomManglerSignaturer: {method: 'GET', url: '/api/dokument/signering/finnDokumenterSomManglerSignaturer'},
            bankidPdfSignertStatus: {method: 'GET', url: '/api/dokument/signering/bankidPdfSignertStatus', params: {dokumentId: '@dokumentId', signatarId: '@signatarId', sign_id: '@sign_id'}},
            bankidPdfSignert: {method: 'GET', url: '/api/dokument/signering/bankidPdfSignert', params: {dokumentId: '@dokumentId', signatarId: '@signatarId', sign_id: '@sign_id'}}
        });
    }

    signatarer(dokumentId: string): l.DokumentSignatarerModell {
        debug('signatarer', dokumentId)
        return this.ressurs['signatarer'](
            {dokumentId: dokumentId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente signatarer'))
        );
    }

    sendTilSignering(dokumentId: string, spesifikasjon: l.SendTilSigneringSpesifikasjon): l.ValideringsresultatModell<l.SignatarValideringfeil> {
        debug('sendTilSignering', dokumentId)
        return this.ressurs['sendTilSignering'](
            _.defaults({dokumentId: dokumentId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke sende signeringsinvitasjon'))
        );
    }

    oppdaterSignatarer(dokumentId: string, spesifikasjon: l.OppdaterSignatarerSpesifikasjon): l.ValideringsresultatModell<l.SignatarValideringfeil> {
        debug('oppdaterSignatarer', dokumentId)
        return this.ressurs['oppdaterSignatarer'](
            _.defaults({dokumentId: dokumentId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke oppdatere signeringsinformasjon'))
        );
    }

    markerSomFerdigSignert(dokumentId: string): l.OkRespons {
        debug('markerSomFerdigSignert', dokumentId)
        return this.ressurs['markerSomFerdigSignert'](
            {dokumentId: dokumentId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke oppdatere signeringsinformasjon'))
        );
    }

    signatarinformasjonForAktivBruker(dokumentId: string): l.PotensiellDokumentSignatarModell {
        debug('signatarinformasjonForAktivBruker', dokumentId)
        return this.ressurs['signatarinformasjonForAktivBruker'](
            {dokumentId: dokumentId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente signaturStatus'))
        );
    }

    /** henter url som benyttes for å vise criipto signeringsgui */
    signerUrl(dokumentId:string, metode:l.Signeringsmetode): l.SignUrlModell {
        debug("signerUrl", metode)
        return this.ressurs["signerUrl"](
            {dokumentId: dokumentId, metode: metode},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente signerUrl"))
        );
    }

    /** Returnerer url som redirigerer klient til url som benyttes for å vise criipto signeringsgui.
     * Bør normalt foretrekkes fremfor signerUrl(..) da vi her unngår problemet med at popup bli blokkert som følge av promise. */
    redirectTilSignerUrl(dokumentId:string, metode:l.Signeringsmetode): string {
        debug("redirectTilSignerUrl", metode)
        return `/api/dokument/signering/${dokumentId}/signerUrl/${metode}?redirect=true`;
    }

    /** Angir at dokumentet har blitt lest av signatar */
    markerSomLest(dokumentId:string): l.OkRespons {
        debug("markerSomLest", dokumentId)
        return this.ressurs["markerSomLest"](
            {dokumentId: dokumentId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke markere dokument som lest"))
        );
    }

    sendSmsOtp(dokumentId: string, spesifikasjon: l.SendSmsOtpSigneringSpesifikasjon): l.SigneringOtpSendtModell {
        debug("sendSmsOtp", dokumentId)
        return this.ressurs["sendSmsOtp"](
          _.defaults({dokumentId: dokumentId}, spesifikasjon),
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke sende SMS-kode"))
        );
    }

    /** @deprecated Bruk signerMedOtp i ng2 i stedet.*/
    signerMedSmsOtp(dokumentId: string, otpKode: string): l.OtpSigneringValideringResponsModell {
        debug("signerMedSmsOtp", dokumentId)
        return this.ressurs["signerMedSmsOtp"](
          {dokumentId: dokumentId, otp: otpKode},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke signere dokument med SMS-kode"))
        );
    }

    sendPurring(dokumentId: string, beskjed: string): l.AntallMeldingerSendtRespons {
        debug('sendPurring', dokumentId)
        return this.ressurs['sendPurring'](
            {dokumentId: dokumentId, beskjed: beskjed},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke sende påminnelse'))
        );
    }

    låsOpp(dokumentId: string): l.OkRespons {
        debug('låsOpp', dokumentId)
        return this.ressurs['låsOpp'](
            {dokumentId: dokumentId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke låse opp dokument'))
        );
    }

    finnDokumenterBrukerIkkeHarSignert(): l.DokumenterTilSigneringModell {
        debug("finnDokumenterBrukerIkkeHarSignert");
        return this.ressurs["finnDokumenterBrukerIkkeHarSignert"](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne usignerte dokumenter"))
        );
    }

    finnDokumenterSomManglerSignaturer(): l.DokumenterTilSigneringModell {
        debug("finnDokumenterSomManglerSignaturer");
        return this.ressurs["finnDokumenterSomManglerSignaturer"](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne usignerte dokumenter"))
        );
    }

    bankidPdfSignertStatus(dokumentId: string, signatarId: string, sign_id: string): l.BankidSigneringStatusModell {
        debug("bankidPdfSignertStatus", dokumentId, signatarId, sign_id);
        return this.ressurs['bankidPdfSignertStatus'](
            {dokumentId: dokumentId, signatarId: signatarId, sign_id: sign_id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente bankid status"))
        );
    }

    bankidPdfSignert(dokumentId: string, signatarId: string, sign_id: string): l.BankidSigneringStatusModell {
        debug("bankidPdfSignert", dokumentId, signatarId, sign_id);
        return this.ressurs['bankidPdfSignert'](
            {dokumentId: dokumentId, signatarId: signatarId, sign_id: sign_id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente bankid status"))
        );
    }

    private håndterFeil(melding: () => string){
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }

}

export interface SignaturmetodeModell {
    metode: l.AkseptertSignaturmetode;
    navn: string;
    sortering: number;
    signeringsmetoder: SigneringsmetodeModell[]
}

export interface SigneringsmetodeModell{
    metode: l.Signeringsmetode;
    logo:any;
    navn: string;
}
